import React from 'react';
import {
    Modal,
    TextInput,
    NumberInput,
    Select,
    SelectItem,
    TextArea,
    Button,
} from '@carbon/react';
import { IWatchfolder } from './Watchfolder.model';

type Props = {
    open: boolean;
    onClose: () => void;
    onSubmit: (folder: IWatchfolder) => void;
};

export const LogsModal: React.FC<Props> = ({ open, onClose, onSubmit }) => {
    const handleSubmit = () => {
        // onSubmit(formData);
        onClose();
    };

    return (
        <Modal
            open={open}
            modalHeading="Logs"
            primaryButtonText="Close"
            // secondaryButtonText="Cancel"
            onRequestClose={onClose}
            onRequestSubmit={handleSubmit}
            preventCloseOnClickOutside={true}
        >
            <div>
                <textarea style={{minHeight: 400, width: "100%", border: "none", background: "none", color: "white", padding: 10}} />
            </div>
        </Modal>
    );
};
